import { render } from "./InteractiveRating.vue?vue&type=template&id=5229d68a&scoped=true&ts=true"
import script from "./InteractiveRating.vue?vue&type=script&lang=ts"
export * from "./InteractiveRating.vue?vue&type=script&lang=ts"

import "./InteractiveRating.vue?vue&type=style&index=0&id=5229d68a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5229d68a"]])

export default __exports__